import React, { useState, useEffect } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { SEOHead } from '../components/ui/SEOHead'
import { TerminalWindow } from '../components/terminal/TerminalWindow'
import { LoadingSpinner } from '../components/ui/LoadingSpinner'
import { subscribersApi } from '../api/subscribersApi'

type State = 'loading' | 'confirmed' | 'invalid' | 'error'

export const SubscribeConfirmPage: React.FC = () => {
  const [params] = useSearchParams()
  const token = params.get('token') ?? ''
  const [state, setState] = useState<State>(token ? 'loading' : 'invalid')

  useEffect(() => {
    if (!token) return
    subscribersApi
      .confirm(token)
      .then((res) => setState(res.success ? 'confirmed' : 'invalid'))
      .catch(() => setState('error'))
  }, [token])

  return (
    <>
      <SEOHead title="Confirming Subscription" />
      <TerminalWindow title="subscribe-confirm.sh">
        <div
          style={{
            fontFamily: "'JetBrains Mono', 'Courier New', monospace",
            fontSize: '0.9rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}
        >
          {state === 'loading' && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'var(--text-secondary)' }}>
              <LoadingSpinner />
              <span>confirming subscription...</span>
            </div>
          )}

          {state === 'confirmed' && (
            <>
              <div style={{ color: 'var(--accent-teal)' }}>✓ Subscription confirmed!</div>
              <div style={{ color: 'var(--text-secondary)' }}>
                You&apos;re on the list. New posts will be delivered to your inbox.
              </div>
              <Link to="/" style={{ color: 'var(--accent-blue)', fontSize: '0.85rem' }}>
                [← back to home]
              </Link>
            </>
          )}

          {state === 'invalid' && (
            <>
              <div style={{ color: 'var(--accent-red, #ff4444)' }}>
                Error: The confirmation link is invalid or has expired.
              </div>
              <div style={{ color: 'var(--text-secondary)' }}>
                Please subscribe again to receive a new confirmation email.
              </div>
              <Link to="/" style={{ color: 'var(--accent-blue)', fontSize: '0.85rem' }}>
                [← back to home]
              </Link>
            </>
          )}

          {state === 'error' && (
            <>
              <div style={{ color: 'var(--accent-red, #ff4444)' }}>
                Error: Something went wrong on our end. Please try again later.
              </div>
              <Link to="/" style={{ color: 'var(--accent-blue)', fontSize: '0.85rem' }}>
                [← back to home]
              </Link>
            </>
          )}
        </div>
      </TerminalWindow>
    </>
  )
}
